"use client";

import { cn } from "@/lib";
import AppContainer from "../appContainer";
import { FlexBetween, FlexCenter } from "../ui";
import Image from "next/image";
import Team2Image from "@public/team2.webp";
import { infoSectionFeatures } from "@/constants";
import { BoCheckCircle } from "solar-icon-react/bo";
import { useTranslations } from "next-intl";

interface InfoSectionProps {
  className?: string;
}

const InfoSection = ({ className }: InfoSectionProps) => {
  const t = useTranslations();
  return (
    <section className={cn("w-full", className)}>
      <AppContainer className={cn("h-full")}>
        <FlexCenter
          className={cn(
            "relative mx-auto w-full items-center gap-10 md:max-w-[700px] lg:max-w-[900px] xl:max-w-full",
          )}
        >
          <div className="absolute top-0 basis-1/2 sm:static">
            <h2
              className={cn(
                "mb-8 block text-center font-bold sm:hidden xl:text-lg",
              )}
            >
              {t("aboutUs.info.title")}
            </h2>
            <figure
              className={cn(
                "from-primary-main/100 to-success-main/0 bg-gradient-to-b",
                "shadow-main flex max-w-[400px] basis-1/2 items-center justify-center overflow-hidden rounded-[15px] p-0.5 sm:max-w-full xl:max-h-[418px]",
              )}
            >
              <Image
                alt="team-image1"
                title="team-image1"
                className={cn("size-full rounded-[14px] object-cover")}
                src={Team2Image}
              />
            </figure>
          </div>
          <article className={cn("mt-90 sm:mt-0 sm:basis-1/2")}>
            <h2 className={cn("mb-4 hidden font-bold sm:block xl:text-lg")}>
              {t("aboutUs.info.title")}
            </h2>
            <div className="text-custom-gray-200 basis-full space-y-6 text-justify text-xs leading-[28px]! sm:text-sm lg:mt-8 xl:text-base">
              <p>
                در دنیای امروز که زمان یکی از ارزشمندترین دارایی‌های افراد است، شرکت گنجینه ارزشمند نوین ایرانیان با ارائه سامانه استعلام نوین وان، با هدف ساده‌سازی فرآیندهای استعلام و پرداخت فعالیت می‌کند.
              </p>
              <p>
                ما با تکیه بر دانش و تخصص تیم خود، تلاش کرده‌ایم بستری سریع، دقیق و امن فراهم کنیم تا کاربران بتوانند به‌سادگی و به‌صورت غیرحضوری، خدمات استعلامی موردنیاز خود را دریافت کنند.
              </p>
              <p>
                هدف ما، تسهیل دسترسی به خدمات دیجیتال، کاهش پیچیدگی فرآیندهای اداری و بانکی و ایجاد تجربه‌ای مطمئن و آسان برای کاربران است.
              </p>
            </div>
            <p
              className={cn(
                "text-custom-gray-200 mt-6 text-xs leading-[28px]! sm:text-sm xl:text-base",
              )}
            >
              {t("aboutUs.info.paragraphTwo")}
            </p>

            <FlexBetween className="absolute right-0 mt-6 flex w-full flex-wrap gap-4 text-sm lg:static lg:mt-10 xl:text-base">
              {infoSectionFeatures.map((feature, index) => (
                <FlexBetween key={index} className="gap-2">
                  <span className="size-5">
                    <BoCheckCircle className="text-secondary-main! size-full!" />
                  </span>
                  <p>{t(feature as any)}</p>
                </FlexBetween>
              ))}
            </FlexBetween>
          </article>
        </FlexCenter>
      </AppContainer>
    </section>
  );
};

export default InfoSection;
